<template>
    <v-container>
        <v-row>
            <v-col cols="8" >
                <h2 class="mt-5">Users</h2>
            </v-col>
            <v-col cols="4" class="text-right">
                <v-btn color="primary" class="mt-5" @click="$refs.history.openAll()">Change Log</v-btn>
            </v-col>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="users"
                    :loading="loading"
                    mobile-breakpoint="100"
                    class="elevation-1 datat users-table"
                >
                    <template v-slot:[`item.kyc`]="{ item }">
                        <div v-if="item.kyc">
                            <v-btn class="white--text ma-2" @click="openUserDoc(item, 'kyc')" color="green" small>
                                View
                            </v-btn>
                            <v-btn class="white--text ma-2" @click="uploadUserDoc(item, 'kyc')" small color="blue">
                                Reupload
                            </v-btn>
                        </div>
                        <v-btn v-else-if="item.status == 'APPROVED'" class="white--text ma-2" @click="uploadUserDoc(item, 'kyc')" small color="green">
                            Upload
                        </v-btn>
                        <div v-else> - </div>
                    </template>
                    <template v-slot:[`item.agreement`]="{ item }">
                        <div v-if="item.agreement">
                            <v-btn class="white--text ma-2" @click="openUserDoc(item, 'agreement')" color="green" small>
                                View
                            </v-btn>
                            <v-btn class="white--text ma-2" @click="uploadUserDoc(item, 'agreement')" small color="blue">
                                Reupload
                            </v-btn>
                        </div>
                        <v-btn v-else-if="item.status == 'APPROVED'" class="white--text ma-2" @click="uploadUserDoc(item, 'agreement')" small color="green">
                            Upload
                        </v-btn>
                        <div v-else> - </div>
                    </template>
                    <template v-slot:[`item.starts_on`]="{ item }">
                        <div @click="updateDate(item, 'START')" v-if="item.starts_on">
                            <a>
                                {{ new Date(item.starts_on).toLocaleDateString('en-IN') }}
                            </a>
                        </div>
                        <v-btn v-else-if="!item.starts_on && item.status == 'APPROVED'" class="ml-2" @click="updateDate(item, 'START')" small color="green" icon>
                            <v-icon color="green">mdi-calendar-edit</v-icon>
                        </v-btn>
                        <div v-else>
                            -
                        </div>
                    </template>
                    <template v-slot:[`item.expires_on`]="{ item }">
                        <div @click="updateDate(item, 'EXPIRED')" v-if="item.expires_on">
                            <a>
                                {{ new Date(item.expires_on).toLocaleDateString('en-IN') }}
                            </a>
                        </div>
                        <div v-else>
                            -
                        </div>
                    </template>
                    <template v-slot:[`item.created_at`]="{ item }">
                        <div @click="updateDate(item, 'JOINED')" v-if="item.created_at">
                            <a>
                                {{ new Date(item.created_at).toLocaleDateString('en-IN') }}
                            </a>
                        </div>
                        <div v-else>
                            -
                        </div>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-btn small icon @click="deleteUser(item)">
                            <v-icon color="red">mdi-delete</v-icon>
                        </v-btn>
                        <v-btn class="white--text" v-if="item.status == 'PENDING'" @click="approveDialog(item)" color="green" small>
                            Approve
                        </v-btn>
                        <v-btn class="white--text" v-if="item.status =='APPROVED'" @click="upPackage(item)" small color="green">Update Package</v-btn>
                        <v-icon small class="ml-2" @click="$refs.history.openForUser(item)">mdi-history</v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card v-if="dialog && docUrl && item">
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialog = false" aria-label="Close document">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{ docLabel }} &mdash; {{ item.name }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <span v-if="docMeta" class="text-caption">{{ docMeta.name }}</span>
                    </v-toolbar>
                    <PdfViewer :pdfUrl="docUrl" />
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog1" max-width="500px">
                <v-card>
                    <v-card-title> Update Package </v-card-title>
                    <v-card-text>
                        <v-select label="Select Package" :items="packageList" v-model="spackage"></v-select>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="white--text" @click="updatePackage" color="green">Update</v-btn>
                        <v-btn class="white--text" @click="dialog1 = false" color="red">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog2" max-width="350px">
                <v-card>
                    <v-card-title v-if="type=='START'">Start Date</v-card-title>
                    <v-card-title v-if="type=='JOINED'">Joined On Date</v-card-title>
                    <v-card-title v-if="type=='EXPIRED'">Expires On Date</v-card-title>
                    <v-card-text>
                        <v-date-picker v-model="sdate"></v-date-picker>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn class="white--text" v-if="type=='START'" @click="updateStartTime" color="green">Update</v-btn>
                        <v-btn class="white--text" v-if="type=='JOINED'" @click="updateJoinTime" color="green">Update</v-btn>
                        <v-btn class="white--text" v-if="type=='EXPIRED'" @click="updateExpireTime" color="green">Update</v-btn>
                        <v-btn class="white--text" @click="dialog2 = false" color="red">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog3" max-width="500">
                <v-card v-if="item">
                    <v-card-title>User Approval</v-card-title>
                    <v-card-text>Approve or Reject user {{ item.name }} / {{ item.email }}?</v-card-text>
                    <v-card-actions>
                        <v-btn class="white--text" @click="approve" color="green">Approve</v-btn>
                        <v-btn class="white--text" @click="reject" color="orange">Reject</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="white--text" @click="dialog3 = false" color="red">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <UserHistory ref="history" />
    </v-container>
</template>

<script>
import { supabase } from '../supabase';
import PdfViewer from './PdfViewer1.vue';
import UserHistory from './UserHistory.vue';

const DOC_LABELS = { kyc: 'KYC', agreement: 'Agreement' };
const MAX_DOC_BYTES = 10 * 1024 * 1024; // must match storage.buckets.file_size_limit
export default {
    data:() => ( {
        headers: [
            { text: 'ID', value: 'id' },
            { text: 'Name', value: 'name' },
            { text: 'Joined On', value: 'created_at' },
            { text: 'Email', value: 'email' },
            { text: 'Phone', value: 'phone' },
            { text: 'KYC', value: 'kyc', sortable: false },
            { text: 'Agreement', value: 'agreement', sortable: false },
            { text: 'Starts On', value: 'starts_on' },
            { text: 'Expires On', value: 'expires_on' },
            { text: 'Status', value: 'status' },
            { text: 'Package', value: 'package' },
            { text: 'Actions', value: 'actions' }
        ],
        users: [],
        dialog: false,
        dialog1: false,
        dialog2: false,
        dialog3: false,
        loading: true,
        type: null,
        item: null,
        docUrl: null,
        docField: null,
        spackage: null,
        sdate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        packageList: ['TRIAL', 'STANDARD', 'PREMIUM'],
    }),

    computed: {
        docLabel() {
            return DOC_LABELS[this.docField] || 'Document';
        },
        docMeta() {
            return this.item && this.docField ? this.item[this.docField] : null;
        },
    },

    watch: {
        // Drop the signed URL and unmount the viewer as soon as the dialog closes.
        dialog(open) {
            if (!open) {
                this.docUrl = null;
                this.docField = null;
            }
        },
    },

    methods: {
        async getUsers() {
            const { data, error } = await supabase
                .from('users')
                .select('*')
                .eq('admin', false)
                .eq('deleted', false)
                .order('created_at', { ascending: false })
                
            if (error) {
                console.error('Error fetching positions:', error);
                this.loading = false;
            } else {
                this.users = data;
                this.loading = false;
            }
        },

        approve() {
            let item = this.item
            if (!confirm('Are you sure you want to approve this user?')) {
                this.dialog3 = false;
                return;
            }
            if (item.status == 'PENDING') {
                supabase
                .from('users')
                .update({ status: 'APPROVED' })
                .eq('id', item.id)
                .then(({ data, error }) => {
                    if (error) {
                        console.error('Error updating user:', error);
                        this.dialog3 = false;
                    } else {
                        console.log('User approved:', data);
                        this.$store.dispatch('createAlert',{type: 'success', message: 'User Approved!'})
                        this.getUsers();
                        this.dialog3 = false;
                    }
                });
            }
        },

        reject() {
            let item = this.item
            if (!confirm('Are you sure you want to reject this user?')) {
                this.dialog3 = false;
                return;
            }
            if (item.status == 'PENDING') {
                supabase
                .from('users')
                .update({ status: 'REJECTED' })
                .eq('id', item.id)
                .then(({ data, error }) => {
                    if (error) {
                        console.error('Error updating user:', error);
                        this.dialog3 = false;
                    } else {
                        console.log('User rejected:', data);
                        this.$store.dispatch('createAlert',{type: 'success', message: 'User Rejected!'})
                        this.getUsers();
                        this.dialog3 = false;
                    }
                });
            }
        },

        approveDialog(item) {
            this.item = item;
            this.dialog3 = true;
        },

        deleteUser(item) {
            if (!confirm('Are you sure you want to delete this user?')) {
                return;
            }
            supabase
                .from('users')
                .update({ deleted: true })
                .eq('id', item.id)
                .then(({ data, error }) => {
                    if (error) {
                        console.error('Error deleting user:', error);
                        this.$store.dispatch('createAlert', { type: 'error', message: 'Failed to delete user' });
                    } else {
                        console.log('User deleted:', data);
                        this.$store.dispatch('createAlert', { type: 'success', message: 'User deleted successfully!' });
                        this.getUsers();
                    }
                });
        },

        uploadUserDoc(item, field) {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'application/pdf';
            input.onchange = async (e) => {
                const file = e.target.files[0];
                if (!file) return;
                if (file.type !== 'application/pdf') {
                    this.$store.dispatch('createAlert', { type: 'error', message: 'Only PDF files are allowed' });
                    return;
                }
                if (file.size > MAX_DOC_BYTES) {
                    this.$store.dispatch('createAlert', { type: 'error', message: 'File must be under 10 MB' });
                    return;
                }
                this.loading = true;
                // Timestamped path, never overwritten: older audit rows keep resolving to
                // the document they actually described.
                const filePath = `users/${item.id}/${field}_${Date.now()}.pdf`;
                const { error: uploadError } = await supabase.storage
                    .from('user-docs')
                    .upload(filePath, file, { contentType: 'application/pdf', upsert: false });
                if (uploadError) {
                    this.$store.dispatch('createAlert', { type: 'error', message: uploadError.message });
                    this.loading = false;
                    return;
                }
                const { error: updateError } = await supabase
                    .from('users')
                    .update({
                        [field]: {
                            path: filePath,
                            name: file.name,
                            size: file.size,
                            uploaded_at: new Date().toISOString(),
                        },
                    })
                    .eq('id', item.id);
                if (updateError) {
                    this.$store.dispatch('createAlert', { type: 'error', message: updateError.message });
                } else {
                    this.$store.dispatch('createAlert', { type: 'success', message: DOC_LABELS[field] + ' uploaded!' });
                    this.getUsers();
                }
                this.loading = false;
            };
            input.click();
        },

        async openUserDoc(item, field) {
            const doc = item[field];
            if (!doc || !doc.path) {
                this.$store.dispatch('createAlert', { type: 'error', message: 'No document on file' });
                return;
            }
            this.loading = true;
            // The bucket is private: reads need a short-lived signed URL, and rendering it
            // through pdf.js keeps that URL out of the address bar and browser history.
            const { data, error } = await supabase.storage
                .from('user-docs')
                .createSignedUrl(doc.path, 300);
            this.loading = false;
            if (error || !data) {
                this.$store.dispatch('createAlert', { type: 'error', message: (error && error.message) || 'Could not open document' });
                return;
            }
            this.item = item;
            this.docField = field;
            this.docUrl = data.signedUrl;
            this.dialog = true;
        },

        upPackage(item) {
            this.item = item;
            this.dialog1 = true;
            this.spackage = item.package || null; 
        },  

        updatePackage() {
            if (!this.spackage) {
                this.$store.dispatch('createAlert', { type: 'error', message: 'Please select a package' });
                return;
            }
            supabase
                .from('users')
                .update({ package: this.spackage })
                .eq('id', this.item.id)
                .then(({ data, error }) => {
                    if (error) {
                        console.error('Error updating package:', error);
                        this.$store.dispatch('createAlert', { type: 'error', message: 'Failed to update package' });
                    } else {
                        console.log('Package updated:', data);
                        this.$store.dispatch('createAlert', { type: 'success', message: 'Package updated successfully!' });
                        this.dialog1 = false;
                        this.getUsers();
                    }
                });
        },

        updateDate(item, type) {
            this.item = item
            this.type = type
            this.dialog2 = true;
        },

        updateStartTime() {
            if (!this.sdate) {
                this.$store.dispatch('createAlert', { type: 'error', message: 'Please select a start date' });
                return;
            }
            // Calculate expires_on as starts_on + 365 days
            const startDate = new Date(this.sdate);
            const expiresDate = new Date(startDate);
            expiresDate.setDate(startDate.getDate() + 365);
            supabase
                .from('users')
                .update({ starts_on: this.sdate, expires_on: expiresDate })
                .eq('id', this.item.id)
                .then(({ data, error }) => {
                    if (error) {
                        console.error('Error updating start time:', error);
                        this.$store.dispatch('createAlert', { type: 'error', message: 'Failed to update start time' });
                    } else {
                        console.log('Start time updated:', data);
                        this.$store.dispatch('createAlert', { type: 'success', message: 'Start time updated successfully!' });
                        this.dialog2 = false;
                        this.type = null;
                        this.getUsers();
                    }
                });
        },

        updateJoinTime() {
            if (!this.sdate) {
                this.$store.dispatch('createAlert', { type: 'error', message: 'Please select a date' });
                return;
            }
            supabase
                .from('users')
                .update({ created_at: this.sdate })
                .eq('id', this.item.id)
                .then(({ data, error }) => {
                    if (error) {
                        console.error('Error updating Date:', error);
                        this.$store.dispatch('createAlert', { type: 'error', message: 'Failed to update' });
                    } else {
                        console.log('Start time updated:', data);
                        this.$store.dispatch('createAlert', { type: 'success', message: 'Date updated successfully!' });
                        this.dialog2 = false;
                        this.type = null;
                        this.getUsers();
                    }
                });
        },

        updateExpireTime() {
            if (!this.sdate) {
                this.$store.dispatch('createAlert', { type: 'error', message: 'Please select a date' });
                return;
            }
            supabase
                .from('users')
                .update({ expires_on: this.sdate })
                .eq('id', this.item.id)
                .then(({ data, error }) => {
                    if (error) {
                        console.error('Error updating Date:', error);
                        this.$store.dispatch('createAlert', { type: 'error', message: 'Failed to update' });
                    } else {
                        console.log('Start time updated:', data);
                        this.$store.dispatch('createAlert', { type: 'success', message: 'Date updated successfully!' });
                        this.dialog2 = false;
                        this.type = null;
                        this.getUsers();
                    }
                });
        }
    },

    components: {
        PdfViewer,
        UserHistory
    },
    mounted() {
        if(this.users == 0) {
            this.getUsers()
        }
    }
}
</script>

<style scoped>
/* The Users table carries 12 columns -- the widest in the app -- so it is the
   one whose header row goes ragged. Scoped on purpose: the shared .datat rules
   in App.vue back six other tables and are deliberately left alone. */
.users-table ::v-deep thead > tr > th {
    height: 48px;
    padding: 0 16px;
    /* "Joined On", "Starts On" and "Expires On" wrapped to two lines while the
       single-word headers stayed on one, so cells had differing heights and the
       labels lost their common baseline. */
    white-space: nowrap;
    vertical-align: middle;
    font-size: 14px;
    /* App.vue asks for font-weight: 1300, outside the legal 1-1000 range, so
       browsers drop the declaration entirely. 700 is what it was reaching for. */
    font-weight: 700;
}

/* Vuetify reserves inline space for the sort arrow on sortable columns only.
   KYC and Agreement are sortable: false, so their labels sat off-centre against
   the other ten. Give them the same phantom gutter the arrow occupies. */
.users-table ::v-deep thead > tr > th:not(.sortable)::after {
    content: "";
    display: inline-block;
    width: 18px;
}
</style>

<!-- <style >
th {
  padding: 15px;
  text-align: left;
  color: #666;
  font-weight: 500;
}

td {
  padding: 15px;
  text-align: left;
  /* background: white; */
}

tr:nth-child(even) td {
  background: #0f1720;
}

/* First and last td in each row for rounded corners */
tr td:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

tr td:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

/* Hover effect */
tr {
  transition: transform 0.2s ease-in-out;
}

tr:hover {
  transform: scale(1.02);
  cursor: pointer;
}

tr:hover td {
  background: #004dc0;
}
</style> -->